"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_ITEM_TYPE = void 0;
var ORDER_ITEM_TYPE;
(function (ORDER_ITEM_TYPE) {
    ORDER_ITEM_TYPE["SINGLE_TILES"] = "Single Tiles";
    ORDER_ITEM_TYPE["PHOTO_WALL"] = "Photo Wall";
    ORDER_ITEM_TYPE["GIFT_CARD"] = "Gift Card";
    ORDER_ITEM_TYPE["PHOTO_BOOK"] = "Photo Book";
    ORDER_ITEM_TYPE["PRODUCT"] = "product";
})(ORDER_ITEM_TYPE = exports.ORDER_ITEM_TYPE || (exports.ORDER_ITEM_TYPE = {}));
//# sourceMappingURL=order.js.map